import React, { useState, useEffect } from "react";
import Link from "next/link";
import { getIconCSSClass } from "../../utils/index";
import BrowserViewGlobal from "../../../Views/BrowserView";
import ActionPointTooltip from "../../ActionPointTooltip";
import useHover from "../../../hooks/useHover";

export default function InternalLink({
  id,
  linkInternal,
  tabindex,
  left,
  top,
  iconKind,
  linkKind,
  title,
  backgroundColor,
}) {
  const [hover, hoverProps] = useHover();

  return (
    <BrowserViewGlobal>
      <Link
        href={linkInternal?.kind === 0 ? "/[event]" : "/[event]/[page]"}
        as={linkInternal?.getFrontendUrl}
      >
        <a
          id={`action-point-${id}`}
          style={{
            top: `${top}%`,
            left: `${left}%`,
            backgroundColor: `#${backgroundColor}`,
          }}
          className={`view__links__dot ${getIconCSSClass(iconKind, linkKind)}`}
          // title={linkInternal?.title}
          tabindex={tabindex}
          {...hoverProps}
        >
          <ActionPointTooltip show={hover} text={title} />
        </a>
      </Link>
    </BrowserViewGlobal>
  );
}
